import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

const SUPPORT_LANG = [
    'en',
    'es',
    'it',
    'pt',
    'fr',
    'pl',
    'de',
    'bg',
    'cs',
    'cy',
    'da',
    'el',
    'et',
    'fi',
    'ga',
    'he',
    'hi',
    'hr',
    'hu',
    'id',
    'is',
    'ja',
    'ko',
    'ku',
    'lt',
    'lv',
    'ml',
    'ms',
    'mt',
    'nb',
    'no',
    'nl',
    'pa',
    'ro',
    'ru',
    'sk',
    'sl',
    'sq',
    'sr',
    'sv',
    'tr',
    'vi',
    'de_ch',
    'zh_cn',
    'zh_tw',
];

i18n.use(HttpApi)
    .use(initReactI18next)
    .init({
        supportedLngs: SUPPORT_LANG,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `locales/{{lng}}/{{ns}}.json`,
        },
        ns: ['common'],
        defaultNS: 'common',
    });

export default i18n;
